import React from "react";
import "./styles/LoginPage.css";
import useAuthService from "../../services/authService";
import LoginForm from "../../components/auth/LoginForm";
import TzBrandMark from "../../components/auth/TzBrandMark";

const LoginPage: React.FC = () => {
  const { login, fetching } = useAuthService();

  const handleSubmit = async (email: string, password: string) => {
    return await login(email, password, {
      onSuccess: () => {
        window.location.href = "/dashboard";
      },
    });
  };

  return (
    <div className="login-wrapper">
      <div className="login-background" aria-hidden="true">
        <div className="login-orb login-orb--orange" />
        <div className="login-orb login-orb--mint" />
        <div className="login-mesh" />
        <div className="grid-pattern" />
      </div>

      <div className="login-container">
        <div className="login-card">
          <div className="login-card-shine" aria-hidden="true" />
          <div className="login-logo-container">
            <TzBrandMark className="login-brand-mark" size={118} />
            <h1 className="login-title">Transportes Zepeda</h1>
          </div>
          <div className="login-form-container">
            <LoginForm onSubmit={handleSubmit} fetching={!!fetching.login} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
